import { useLenis } from "lenis/react";
import Reveal from "@/components/Reveal";
import { FlowerLotus } from "@phosphor-icons/react";
import { useLang } from "@/i18n";

export default function Footer() {
  const lenis = useLenis();
  const { t } = useLang();
  const go = (href) => (e) => {
    e.preventDefault();
    if (lenis) lenis.scrollTo(href, { offset: -70, duration: 1.4 });
    else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="border-t border-forest/10 bg-forest text-cream" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <Reveal>
          <div className="flex items-center gap-4">
            <FlowerLotus size={30} weight="duotone" className="text-sagedeep" />
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-cream/60">{t.footer.tagline}</p>
          </div>
          <h2 className="mt-8 font-serif text-5xl italic leading-none tracking-tight md:text-7xl lg:text-8xl" data-testid="footer-brand">
            Heal &amp; Balance
          </h2>
          <p className="mt-4 text-xs font-semibold uppercase tracking-[0.3em] text-cream/60">Cécile DC Kinnunen</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-cream/15 pt-10 md:grid-cols-3">
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              { label: t.nav.about, href: "#about" },
              { label: t.nav.practices, href: "#practices" },
              { label: t.nav.specialties, href: "#specialties" },
              { label: t.nav.sessions, href: "#sessions" },
              { label: t.nav.contact, href: "#contact" },
            ].map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={go(l.href)}
                data-testid={`footer-link-${l.href.slice(1)}`}
                className="link-underline text-xs font-semibold uppercase tracking-[0.2em] text-cream/70 transition-colors hover:text-cream"
              >
                {l.label}
              </a>
            ))}
          </div>
          <p className="text-xs leading-relaxed text-cream/50 md:col-span-2 md:text-right" data-testid="footer-disclaimer">
            {t.footer.disclaimer}
          </p>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 text-xs text-cream/40 md:flex-row md:items-center">
          <span>© 2026 Heal &amp; Balance · healandbalance.com — Katy &amp; Houston, Texas</span>
          <a href="mailto:cecilekinnunen@gmail.com" className="link-underline" data-testid="footer-email-link">
            cecilekinnunen@gmail.com
          </a>
        </div>
      </div>
    </footer>
  );
}
